import { isFlagEnabled } from "js/utilities";
import { useTranslation } from "react-i18next";

export const useCustomerFaqs = () => {
  const { t } = useTranslation();
  return [
    {
      title: t("CustomerFaq-title-1"),
      desc: isFlagEnabled("ENABLE_SERVICE_TRACKING")
        ? t("CustomerFaq-desc-release")
        : t("CustomerFaq-desc-1"),
    },
    {
      title: t("CustomerFaq-title-2"),
      desc: t("CustomerFaq-desc-2"),
    },
    {
      title: t("CustomerFaq-title-3"),
      desc: t("CustomerFaq-desc-3"),
    },
    {
      title: t("CustomerFaq-title-4"),
      desc: t("CustomerFaq-desc-4"),
    },
    {
      title: t("CustomerFaq-title-5"),
      desc: t("CustomerFaq-desc-5"),
    },
    {
      title: t("CustomerFaq-title-6"),
      desc: isFlagEnabled("ENABLE_VA_PHONE_NUMBER_IN_FAQ")
        ? t("CustomerFaq-desc-6")
        : t("CustomerFaq-desc-7"),
    },
    {
      title: t("CustomerFaq-title-7"),
      desc: t("CustomerFaq-desc-8"),
    },
    {
      title: t("CustomerFaq-title-8"),
      desc: isFlagEnabled("ENABLE_VA_PHONE_NUMBER_IN_FAQ")
        ? t("CustomerFaq-desc-9")
        : t("CustomerFaq-desc-10"),
    },
    {
      title: t("CustomerFaq-title-9"),
      desc: isFlagEnabled("ENABLE_VA_PHONE_NUMBER_IN_FAQ")
        ? t("CustomerFaq-desc-11")
        : t("CustomerFaq-desc-12"),
    },
    {
      title: t("CustomerFaq-title-10"),
      desc: t("CustomerFaq-desc-13"),
    },
    {
      title: t("CustomerFaq-title-11"),
      desc: isFlagEnabled("ENABLE_VA_PHONE_NUMBER_IN_FAQ")
        ? t("CustomerFaq-desc-14")
        : t("CustomerFaq-desc-15"),
    },
    {
      title: t("CustomerFaq-title-16"),
      desc: isFlagEnabled("ENABLE_VA_PHONE_NUMBER_IN_FAQ")
        ? t("CustomerFaq-desc-16")
        : t("CustomerFaq-desc-17"),
    },
    {
      title: t("CustomerFaq-title-18"),
      desc: t("CustomerFaq-desc-38"),
    },
    {
      title: t("CustomerFaq-title-40"),
      desc: t("CustomerFaq-desc-40"),
    },
  ];
};
